import axios from "axios";
import { get } from "lodash";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
    REQUEST_MASTER_MOBILE_PRODUCT,
    REQUEST_CREATE_MASTER_MOBILE_PRODUCT,
    REQUEST_UPDATE_MASTER_MOBILE_PRODUCT,
    SET_MASTER_MOBILE_PRODUCT,
    SUCCESS_CREATE_MASTER_MOBILE_PRODUCT,
    SUCCESS_UPDATE_MASTER_MOBILE_PRODUCT,
    ERROR_GET_MASTER_MOBILE_PRODUCT,
    ERROR_CREATE_MASTER_MOBILE_PRODUCT,
    ERROR_UPDATE_MASTER_MOBILE_PRODUCT,
} from "./mobileproductActionTypes"

function* requestMasterMobileProduct(action: Record<string, any>): any {
    try {
        const result: any = yield call(getMobileProductMaster);
        yield put({ type: SET_MASTER_MOBILE_PRODUCT, payload: result.data });
        // console.warn(result.data);
        
    } catch (error: any) {
        console.log(error);
        let message =
            "Something went wrong, please try again after some time or Refresh the Page.";
        if (get(error, "response.status") === 500) {
            message = "Something happened wrong try again after sometime.";
        } else if (get(error, "response.status") === 422) {
            message = error.response.data.message || "please provide valid contain";
        } else if (get(error, "response.status") === 415) {
            message = error.response.data.message;
        }
        yield put({ type: ERROR_GET_MASTER_MOBILE_PRODUCT, payload: message });
    }
}

function* requestUpdateMasterMobileProduct(action: Record<string, any>): any {
    try {
        const result = yield call(
            updateMasterMobileProduct,
            action.data.payload,
            action.data._id
        )
        yield put({
            type: SUCCESS_UPDATE_MASTER_MOBILE_PRODUCT,
            payload: result.data,
        });
    } catch (error: any) {
        console.log(error);
        let message =
            "Something went wrong, please try again after some time or Refresh the Page.";
        if (get(error, "response.status") === 500) {
            message = "Something happened wrong try again after sometime.";
        } else if (get(error, "response.status") === 422) {
            message = error.response.data.message || "please provide valid contain";
        } else if (get(error, "response.status") === 415) {
            message = error.response.data.message;
        }
        yield put({ type: ERROR_UPDATE_MASTER_MOBILE_PRODUCT, payload: message });
    }
}

function* requestCreateMasterMobileProduct(action: Record<string, any>): any {
    try {
        const result = yield call(createMasterMobileProduct, action.payload);
        yield put({
            type: SUCCESS_CREATE_MASTER_MOBILE_PRODUCT,
            payload: result.data,
        });
        // update relevant category as well
    } catch (error: any) {
        console.log(error);
        let message =
            "Something went wrong, please try again after some time or Refresh the Page.";
        if (get(error, "response.status") === 500) {
            message = "Something happened wrong try again after sometime.";
        } else if (get(error, "response.status") === 422) {
            message = error.response.data.message || "please provide valid contain";
        } else if (get(error, "response.status") === 415) {
            message = error.response.data.message;
        }
        yield put({ type: ERROR_CREATE_MASTER_MOBILE_PRODUCT, payload: message });
    }
}


export function getMobileProductMaster() {
    return axios({
        method: "GET",
        url: `${process.env.REACT_APP_BASE_URL}/mobileProduct`,
        withCredentials: true,
    });
}

export function updateMasterMobileProduct(payload: Record<string, any>, _id: string) {
    return axios({
        method: "patch",
        url: `${process.env.REACT_APP_BASE_URL}/mobileProduct/${_id}`,
        data: payload,
        withCredentials: true,
    });
}

export function createMasterMobileProduct(payload: Record<string, any>) {
    return axios({
        method: "post",
        url: `${process.env.REACT_APP_BASE_URL}/mobileProduct`,
        data: payload,
        withCredentials: true,
    });
}


const mobileproductMasterSaga = function* () {
    yield all([
        takeLatest(REQUEST_MASTER_MOBILE_PRODUCT, requestMasterMobileProduct),
        takeLatest(REQUEST_UPDATE_MASTER_MOBILE_PRODUCT, requestUpdateMasterMobileProduct),
        takeLatest(REQUEST_CREATE_MASTER_MOBILE_PRODUCT, requestCreateMasterMobileProduct),

    ])
}

export default mobileproductMasterSaga;